import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-05/lesson-22/task-04";

const task: Slide = {
  titleHtml:
    "If we measure the reverberation time in receiving room ( V= 30 m<sup>3</sup>)  T=0,5 s, levels in<br>the source and in the receiving room as L<sub>1</sub> = 95 dB and L<sub>2</sub> = 45 dB at 500 Hz the<br>sound reduction index and normalized level difference are:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
